import { render, staticRenderFns } from "./ResourceDirectoryMain.vue?vue&type=template&id=4fc07a51&scoped=true&"
import script from "./ResourceDirectoryMain.vue?vue&type=script&lang=js&"
export * from "./ResourceDirectoryMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc07a51",
  null
  
)

export default component.exports